<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">

    <div class="w-full p-2 flex-1">
      <div class="flex justify-center gap-2 mb-4">
        <button (click)="onCancel()"
          class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">Retour</button>
      </div>
      <h2 class="flex text-lg font-bold justify-center m-4">Nombre de personnes</h2>

      <div class="flex justify-center items-center gap-4 m-4">
        <button mat-mini-fab color="primary" (click)="decreasePeople()" [disabled]="numberOfPeople <= 2">
          <mat-icon>remove</mat-icon>
        </button>
        <span class="text-lg">{{ numberOfPeople }}</span>
        <button mat-mini-fab color="primary" (click)="increasePeople()">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <!-- Section : Payer pour X personnes -->

      <h2 class="flex text-lg font-bold justify-center m-4">Payer pour</h2>
      <div class="flex justify-center items-center gap-4 mb-4">
        <button mat-mini-fab color="primary" (click)="decreasePaidFor()" [disabled]="paidFor <= 1">
          <mat-icon>remove</mat-icon>
        </button>
        <span class="text-lg">{{ paidFor }} personne<span *ngIf="paidFor > 1">s</span></span>
        <button mat-mini-fab color="primary" (click)="increasePaidFor()" [disabled]="paidFor >= numberOfPeople">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div class="mb-4">
        <p class="flex justify-center text-sm text-gray-500">
          Montant total :
          <strong>{{ data.totalAmount | number: data.currencyFormat.decimalsString }}
            {{data.currencyFormat.currencySymbol}}</strong>
        </p>
        <p class="flex justify-center text-sm text-gray-500">
          Chacun paiera environ :
          <strong>{{ (data.totalAmount / numberOfPeople) | number: data.currencyFormat.decimalsString }}
            {{data.currencyFormat.currencySymbol}}</strong>
        </p>

        <p class="flex justify-center text-sm text-gray-500">
          Votre paiement sera de :
          <strong>{{ (data.totalAmount / numberOfPeople) * paidFor | number: data.currencyFormat.decimalsString }}
            {{data.currencyFormat.currencySymbol}}</strong>
        </p>
      </div>

      <div class="flex justify-center gap-2">
        <button (click)="onConfirm((data.totalAmount / numberOfPeople) * paidFor)"
          class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">Valider</button>
      </div>
    </div>
 </app-dialog-wrapper>